import RouteTemplate from 'ember-route-template';

import Component from '@glimmer/component';
import { pageTitle } from 'ember-page-title';

import UiPage from 'rise-ui/components/ui-page.gjs';

export default RouteTemplate(class VisualizationsTemplate extends Component {
  <template>
    {{pageTitle "Visualizations"}}

    <UiPage @page={{@model.visualizations}}>
      <:title>Visualizations</:title>
      <:error>Visualizations content could not be loaded. Please try back later.</:error>
      <:body>Loading Visualizations...</:body>
    </UiPage>
    {{outlet}}
  </template>
});
